import React, { useEffect, useState } from 'react'
import ReactGoogleAutocomplete, {
    geocodeByPlaceId,

} from "react-google-places-autocomplete";
import { Option } from 'react-google-places-autocomplete/build/types';
import { ActionMeta, SingleValue } from 'react-select';

interface GoogleAutocompleteProps {
    googlePlacesId: string | null;
    onPlaceChange: (lat: number | null, long: number | null, googlePlacesId: string | null) => void;
}

const GoogleAutocompleteInput = ({ googlePlacesId, onPlaceChange }: GoogleAutocompleteProps) => {
    const [defaultPlace, setDefaultPlace] = useState<any>(null); // State to store default place

    const fetchPlaceDetails = async (placeId: string) => {
        try {
            const results = await geocodeByPlaceId(placeId);
            const place = results[0];
            if (place) {
                setDefaultPlace({
                    label: place.formatted_address,
                    value: place,
                });
            }
        } catch (error) {
            console.error("Error fetching place details:", error);
        }
    };

    useEffect(() => {
        if (googlePlacesId) {
            fetchPlaceDetails(googlePlacesId);
        }
    }, [googlePlacesId]);

    const handleGetZipCode = async (address: SingleValue<Option>) => {

        if (address?.label) {
            try {
                const results = await geocodeByPlaceId(address.value.place_id);
                const result = results[0];

                const lat = result.geometry.location.lat();
                const lng = result.geometry.location.lng();

                onPlaceChange(lat, lng, address.value.place_id)
            } catch (error) {
                console.error('Error fetching address details:', error);
            }
        } else {
            onPlaceChange(null, null, null);
            setDefaultPlace(null)
        }
    };

    return (
        <ReactGoogleAutocomplete
            selectProps={{
                isClearable: true,
                backspaceRemovesValue: true,
                placeholder: 'Search Location',
                name: 'place',
                onChange: (newValue: SingleValue<Option>, actionMeta: ActionMeta<Option>) => handleGetZipCode(newValue),
                className: 'googleSelect',
                value: defaultPlace,
                classNamePrefix: 'customGoogleSelect'

            }}

        />
    );
};

export default GoogleAutocompleteInput;

